export const SET_API_JSON = 'SET_API_JSON'
export const SET_API_JSON_ERROR = 'SET_API_JSON_ERROR'
export const SET_USER_DATA = 'SET_USER_DATA'
export const SET_PAGINATION = 'SET_PAGINATION'
export const SET_USER_LIST = 'SET_USER_LIST'
export const SET_USER_PAGINATION = 'SET_USER_PAGINATION'
export const SET_ACCOUNT_LIST = 'SET_ACCOUNT_LIST'
export const SET_BOOK_LIST = 'SET_BOOK_LIST'